import axios from '../../plugins/axios'

export const login = ({ commit }, user) => {
  return axios.post('/login', user)
    .then((response) => {
      const user = response.data
      commit('SET_USER', { user })
      return response
    },
    (error) => {
      console.error(error)
    }
    )
}

export const logout = ({ commit }) => {
  commit('SET_USER', { user: null })
  commit('SET_PERMISSIONS', [])
}

export const sendRecoverPasswordEmail = (_, { email }) => {
  if (email && email !== '') {
    return axios.post('/auth/recover_password_email', { email })
      .catch((error) => {
        console.error(error)
      })
  }
}

export const changeUserPassword = (_, { password, token }) => {
  if (password && password !== '') {
    const header = { headers: { Authorization: `bearer ${token}` } }
    return axios.put('/auth/change_password', { password }, header)
      .catch((error) => {
        console.error(error)
      })
  }
}

export const checkEmailAvailability = (_, { email }) => {
  if (email && email !== '') {
    return axios.get('/auth/check-email', { params: { email } })
      .catch((error) => {
        console.error(error)
      })
  }
}

export const sendVerificationCode = (_, { email, name }) => {
  if (email && email !== '') {
    return axios.post('/email-verification/send-verification-code', { email, name })
      .catch((error) => {
        console.error(error)
        return error.response
      })
  }
}

export const verifyEmail = (_, { email, code }) => {
  if (email && email !== '' && code && code !== '') {
    return axios.post('/email-verification/verify', { email, code })
      .catch((error) => {
        console.error(error)
        return error.response
      })
  }
}

export const fetchPermissions = async ({ commit }) => {
  const response = await axios.get('/auth/permissions')
  commit('SET_PERMISSIONS', response.data.permissions)
}
